import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import { useScrollReveal } from "../../hooks/useScrollReveal";

function About() {
  useScrollReveal();

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col md={7} style={{ justifyContent: "center", paddingTop: "30px", paddingBottom: "50px" }}>
            <h1 className="reveal" style={{ fontSize: "2.1em", paddingBottom: "20px", fontFamily: "var(--font-display)", fontWeight: 800, letterSpacing: "-0.03em" }}>
              Know Who <span className="purple">I AM</span>
            </h1>
            <div className="reveal reveal-delay-1">
              <Aboutcard />
            </div>
          </Col>
          <Col md={5} style={{ paddingTop: "100px", paddingBottom: "50px" }} className="about-img reveal reveal-delay-2">
            <img src={laptopImg} alt="about" className="img-fluid" style={{ filter: "drop-shadow(0 0 30px rgba(180,79,255,0.2))" }} />
          </Col>
        </Row>

        <h1 className="project-heading reveal">
          Professional <span className="purple">Skillset</span>
        </h1>
        <div className="reveal reveal-delay-1">
          <Techstack />
        </div>

        <h1 className="project-heading reveal">
          <span className="purple">Tools</span> I Use
        </h1>
        <div className="reveal reveal-delay-1">
          <Toolstack />
        </div>

        <div className="reveal">
          <Github />
        </div>
      </Container>
    </Container>
  );
}

export default About;